const VideoIcon = ({ viewBox = "0 0 20 20", className = "hayley-h-5 hayley-w-5 hayley-text-secondary" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <path d="M7.5 5.83325L14.1667 9.99992L7.5 14.1666V5.83325Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M19 17V3C19 1.89543 18.2674 1 17.3636 1L2.63636 1C1.73263 1 1 1.89543 1 3V17C1 18.1046 1.73263 19 2.63636 19H17.3636C18.2674 19 19 18.1046 19 17Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default VideoIcon;
